"use client"

import React from "react"
import { FormattedMessage } from "react-intl"

import { Box, H2, Icon, P } from "@bullseye/components"

import SignUpButton from "../SignUpButton"
import AnimatedImage from "./AnimatedImage"

const SafetyFriendship = () => (
  <Box className="flex items-center px-4 py-20">
    <Box className="max-w-[1200px] flex-1 flex-col flex-nowrap items-center rounded-lg bg-primary-50 p-6 g-10 md:flex-row md:p-10">
      <AnimatedImage
        src={
          "https://storage.googleapis.com/hank-app-assets/marketing/Hank4101.jpg"
        }
        alt={"Safety first. Friendship second. (But still really important.)"}
      />
      <Box className="flex-1 justify-center">
        <Box className="flex items-start g-4">
          <Icon
            className="h-[33px] w-[33px] stroke-2"
            type="shield-outline"
            color="text-primary-500"
          />
          <H2 className="text-brand-indigo-1">
            Safety first. Friendship second. (But still really important.)
          </H2>
          <P>
            Hank puts safety first — always. From small, welcoming groups to
            clear community standards and a hands-on team supporting every step,
            you can show up with confidence and focus on having fun.
          </P>
          <SignUpButton>
            <FormattedMessage id="general.getStarted.free" />
          </SignUpButton>
        </Box>
      </Box>
    </Box>
  </Box>
)

export default SafetyFriendship
